var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InternalLayout',[_c('FormSection',{attrs:{"title":_vm.$t('SETTINGS.TWO_STEP_VERIFICATION.TITLE'),"description":_vm.$t('SETTINGS.TWO_STEP_VERIFICATION.DESCRIPTION')}},[_c('TwoStepVerificationActivateForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }